import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { BREAKPOINT, BreakpointService, CurrentProductService, ProductImagesComponent } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { ShimanoUtilMethod } from 'src/app/utility/methods.util';
import { SlickCarouselUtilService } from 'src/app/utility/slick-carousel.util';

@Component({
  selector: 'app-shimano-product-images',
  templateUrl: './shimano-product-images.component.html',
  styleUrls: ['./shimano-product-images.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShimanoProductImagesComponent extends ProductImagesComponent implements OnInit, OnDestroy {
  slickConfig: any;
  isMobile = false;
  isTablet = false;
  galleryOpen = false;
  hasOpenImage = false;
  hasImage = false;
  timeout: any = null;
  productSubscription$: Subscription;
  thumbSubscription$: Subscription;
  csDesktopWidth = this.breakpointService.getSize(BREAKPOINT.lg);
  csTabletWidth = this.breakpointService.getSize(BREAKPOINT.sm);
  detectChangeUrl = 0;
  img_mainImage$: Observable<any>;
  newThumbs$: Observable<any>[];
  result: any;
  businessType: string;

  constructor(
    protected currentProductService: CurrentProductService,
    private componentService: ComponentService,
    private deviceService: DeviceDetectorService,
    private breakpointService: BreakpointService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private currentBusinesstype: CurrentBusinessType,
    private storageService: StorageService
  ) {
    super(currentProductService);
    const imageZoom = document.querySelector('app-shimano-image-zoom');
    imageZoom.setAttribute('style', 'display:none');
    const slickConfig = new SlickCarouselUtilService();
    const slickObj = slickConfig.defaultConfig;
    slickObj.slidesToShow = 4;
    slickObj.slidesToScroll = 4;
    if (!this.deviceService.isDesktop()) {
      slickObj.arrows = false;
      slickObj.responsive[0].settings.slidesToShow = 4;
      slickObj.responsive[0].settings.slidesToScroll = 1;
      slickObj.responsive[1].settings.slidesToShow = 4;
      slickObj.responsive[1].settings.slidesToScroll = 1;
      slickObj.responsive[2].settings.slidesToShow = 4;
      slickObj.responsive[2].settings.slidesToScroll = 1;
    }
    this.slickConfig = slickObj;
    this.isMobile = window.innerWidth < this.csTabletWidth;
    this.isTablet = window.innerWidth < this.csDesktopWidth && window.innerWidth >= this.csTabletWidth;
    router.events.subscribe((val: any) => {
      this.detectChangeUrl++;
      if (typeof val.shouldActivate !== 'undefined' && this.detectChangeUrl === 6) {
        this.storageService.setSessionStorageItem('pdp-product', null);
        this.detectChangeUrl = 0;
      }
    });
  }

  openImages(item: any, isGallery: boolean): void {
    this.hasOpenImage = true;
    this.galleryOpen = isGallery;
    this.mainMediaContainer.next(item);
    this.cdr.detectChanges();
    if (isGallery) {
      const element = document.querySelector('.gallery cx-media');
      element?.classList?.remove('is-active');
    }
  }

  isActive(thumbnail: any): Observable<boolean> {
    return this.mainMediaContainer.pipe(
      filter(Boolean),
      map((container: any) => {
        return (
          container.gallery &&
          container.gallery.galleryIndex &&
          thumbnail.gallery &&
          thumbnail.gallery.galleryIndex &&
          container.gallery.galleryIndex === thumbnail.gallery.galleryIndex
        );
      })
    );
  }

  isActivePrimary(thumbnail: any): Observable<boolean> {
    return this.mainMediaContainer.pipe(
      filter(Boolean),
      map((container: any) => {
        return (
          container.product &&
          container.product.url &&
          thumbnail.product &&
          thumbnail.product.url &&
          container.product.url === thumbnail.product.url
        );
      })
    );
  }

  /**
   * Return the image rendition based on the size
   */
  getImageRendition(image: any, type: string) {
    let size: string;
    if (this.isMobile || this.isTablet) {
      if (type === 'primary') {
        size = ShimanoUtilMethod.imageRendition(295);
      } else {
        size = ShimanoUtilMethod.imageRendition(80);
      }
    } else {
      if (type === 'primary') {
        size = ShimanoUtilMethod.imageRendition(572);
      } else {
        size = ShimanoUtilMethod.imageRendition(98);
      }
    }

    return ShimanoUtilMethod.newImageFormat(image, size);
  }

  ngOnInit(): void {
    this.thumbSubscription$ = this.thumbs$.subscribe((data: any) => {
      this.result = data.filter((element: any): element is string => {
        return element !== null;
      });
      this.newThumbs$ = this.result;
    });
    setTimeout(() => {
      this.img_mainImage$ = this.mainImage$;
      this.productSubscription$ = this.img_mainImage$.subscribe((data) => {
        //Image is rendered here after init
        const thumb = '.thumb.1280.1280.png';
        if (typeof data !== 'undefined') {
          if (typeof data.product !== 'undefined') {
            this.storageService.setSessionStorageItem('pdp-product-full', `${data.product.url}${thumb}`);
            this.storageService.setSessionStorageItem(
              'pdp-product',
              this.getImageRendition(data.product, 'primary').url
            );
            this.hasImage = true;
            this.componentService.setProductPDP(true);
            this.cdr.detectChanges();
          } else {
            if (typeof data.gallery !== 'undefined') {
              this.storageService.setSessionStorageItem('pdp-product-full', `${data.gallery.url}${thumb}`);
              this.storageService.setSessionStorageItem(
                'pdp-product',
                this.getImageRendition(data.gallery, 'primary').url
              );
              this.hasImage = true;
              if (this.hasOpenImage) {
                this.componentService.setProductPDP(true);
              }
              this.cdr.detectChanges();
            } else {
              this.storageService.setSessionStorageItem('pdp-product', null);
              this.storageService.setSessionStorageItem('pdp-product-full', null);
            }
          }
        }
      });
    });
    this.businessType = this.currentBusinesstype.getBusinessType();
  }

  ngOnDestroy() {
    if (this.productSubscription$) {
      this.productSubscription$.unsubscribe();
    }
    if (this.thumbSubscription$) {
      this.thumbSubscription$.unsubscribe();
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
